import React from 'react'
import { Icon } from 'antd'
import { SyncOutlined } from '@ant-design/icons'

import './StepTitle.scss'

function StepTitle({
  iconType = '',
  title = '',
  description = '',
  isLoading = false,
  progress = {}
}) {
  return (
    <div className="video-generation__step-title">
      <div className="video-generation__step-title__icon">
        <Icon type={iconType} />
      </div>

      <div className="video-generation__step-title__content">
        <h1>{title}</h1>
        <p>{description}</p>
      </div>

      {isLoading && (
        <div className="video-generation__step-title__loading">
          <SyncOutlined spin />

          <span>
            Generation in progress...({progress.current}/{progress.total}{' '}
            completed)
          </span>
        </div>
      )}
    </div>
  )
}

export default StepTitle
